export default [
    {code: 'Submit', label: '待审批'},
    {code: 'Reject', label: '已驳回'},
    {code: 'Approve', label: '待制证'},
    {code: 'Printed', label: '待发证'},
    {code: 'ChangeMail',label:'邮寄变更'},
    {code: 'Mailed', label: '待计费'},
    {code: 'Paid', label: '已完结'},
]